export default {
  state: {
    common: {
      menus: "menus",
      languages: "base",
      getBrokerList: "company_list", //商户列表
    },
    // 登录模块
    login: {
      login_in: "login",
    },
    // 多语言
    languageManage: {
      languageDiff: 'language_diff',
      updateLanguage: 'update_language',
      getDiffLanguageInfo: 'get_diff_language_info',
      ignoringChanges: 'ignoring_changes',
      updateChangeKeyContent: 'update_change_key_content',
    },
    // 经纪人系统
    agent: {
      index: 'index',//看板
      set_cash_scale: 'set_cash_scale',//返现设置
      user_list: 'user_list',//用户列表
      company_list: 'company_list',//商户列表
      return_amount_day: 'return_amount_day',//我的每日返佣usdt
      user_bonus_list: 'user_bonus_list',//返佣明细
      co_agent_user_list: 'co_agent_user_list',//经纪人列表查询接口
      user_bonus_stat_list: 'user_bonus_stat_list',//返佣统计
      co_agent_role_list: 'co_agent_role_list',//经纪人角色列表查询
      co_agent_role_menu_list: 'co_agent_role_menu_list',//经纪人列表弹窗角色下拉
      kv_list: 'kv_list',//KV列表
      kv_set: 'kv_set',//kv 配置
      account_info: 'account_info',//账户配置
      direct_scale_set: 'direct_scale_set',//商户直推比例
      public_info: 'common/public_info',//公共接口
      email: 'email',//经纪人用户列表邮箱手机模糊查询(假的)
      co_agent_user_set: 'co_agent_user_set',//经纪人列表冻结解冻
      get_user_info: 'get_user_info',//经纪人列表弹窗获取用户信息
      co_agent_role_set: 'co_agent_role_set',//角色列表删除
      account_type_list: 'account_type_list',//转账列表
      level_list: 'level_list',//返佣级别下拉
      getMarginCoinList: "get_coin_list", // 保证金币种列表
      up_info: 'up_info',//经纪人看板4个图表数据
      overview: 'overview', //经纪人总览4个图表
      user_amount: 'user_amount', //用户资产列表
      co_agent_team: 'co_agent_team', //经纪人团队
      bonus_transactions: 'bonus_transactions', //奖励账户添加流水
      getAllOpenContract: "getAllOpenContract", // 合约名称列表
      positionPage: "positionPage", // 持仓位列表
      orderPage: "orderPage", // 普通委托列表
      inAndOutDetail: "inAndOutDetail", // 出入金明细
      get_export_info: 'get_export_info', // 导出
      updateInviteCode: 'updateInviteCode',
    },

  },
};
